// fork overlay: fork-owned extension of OSS v4.13.0 (blob:f3e2bb6ec702082e)
// FEAT-002 (issue #18): wholesale replacement adding the /campaigns/api route.
// Alias-form imports (D-07) let the overlay plugin resolve the fork APICampaignsPage.
import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from 'dashboard/routes/dashboard/campaigns/pages/CampaignsPageRouteView.vue';
import LiveChatCampaignsPage from 'dashboard/routes/dashboard/campaigns/pages/LiveChatCampaignsPage.vue';
import SMSCampaignsPage from 'dashboard/routes/dashboard/campaigns/pages/SMSCampaignsPage.vue';
import WhatsAppCampaignsPage from 'dashboard/routes/dashboard/campaigns/pages/WhatsAppCampaignsPage.vue';
import APICampaignsPage from 'dashboard/routes/dashboard/campaigns/pages/APICampaignsPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'campaigns_ongoing_index', params: to.params };
          },
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_livechat_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_sms_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          component: LiveChatCampaignsPage,
        },
        {
          path: 'sms',
          name: 'campaigns_sms_index',
          meta,
          component: SMSCampaignsPage,
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignsPage,
        },
        {
          path: 'api',
          name: 'campaigns_api_index',
          meta,
          component: APICampaignsPage,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
